import { render, staticRenderFns } from "./clearance-history.vue?vue&type=template&id=06ea685f&scoped=true&"
import script from "./clearance-history.vue?vue&type=script&lang=js&"
export * from "./clearance-history.vue?vue&type=script&lang=js&"
import style0 from "./clearance-history.vue?vue&type=style&index=0&id=06ea685f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ea685f",
  null
  
)

export default component.exports